import gql from 'graphql-tag';
import { fileOperation } from '@shared/api/fragments/fileOperation';

export const listFileOperations = gql`
  query ListFileOperationsQuery($input: ListFileOperations!) {
    listFileOperations(input: $input) {
      items {
        ...FileOperation
      }
      hasMore
    }
  }

  ${fileOperation}
`;
